<div class="generic-modal-root">

  <ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

  <form [formGroup]="form" *ngIf="form">
  <div class="row-padding">
    <div class="row">
      <table style="width: 1000px;">   
            <tr>         
              <td class="row-padding">
                <span>Application Name</span>
              </td>
              <td class="row-padding">
                <input
                  class="input-style"
                  formControlName="applicationName"
                  type="text"/>
              </td>
            </tr>

            <tr >         
              <td class="row-padding">
                <span>API Key</span>
              </td>
              <td *ngIf="!engine" style="width: 100%; padding: 15px;">
                <input
                  class="input-style"
                  formControlName="apiKey"
                  type="text"/>
                  <button 
                    type="button" 
                    class="color-black" 
                      (click)="generateApiKey()">
                      Auto Generate
                    </button>
                    
              </td>
              <td *ngIf="engine" style="width: 100%; padding: 15px;">
                <span  style="color:red;">Cannot edit existing API keys</span>
                    
              </td>
            </tr>

            <tr>         
              <td class="row-padding">
                <span>Config</span>
              </td>
              <td class="row-padding">
                <select
                  style="width: 250px; color: black; height: 24px;"
                  id="configs"
                  formControlName="engineConfigId"
                  [compareWith]="compare" 
                  name="configs">
                    <option *ngFor="let c of configs" [ngValue]="c.cueConfigId">
                        {{c.name}}
                    </option>
                </select>
              </td>
            </tr>

            <tr>         
              <td class="row-padding">
                <span>Google Play Store Package Name</span>
              </td>
              <td class="row-padding">
                <input
                  class="input-style"
                  formControlName="playStoreId"
                  type="text"/>
              </td>
            </tr>

            <tr>         
              <td class="row-padding">
                <span>Apple App Store Name</span>
              </td>
              <td class="row-padding">
                <input
                  class="input-style"
                  formControlName="appleStoreName"
                  type="text"/>
              </td>
            </tr>

            <tr>         
              <td class="row-padding">
                <span>Apple App Store ID</span>
              </td>
              <td class="row-padding">
                <input
                  class="input-style"
                  formControlName="appleStoreId"
                  type="text"/>
              </td>
            </tr>

            <tr>         
              <td class="row-padding">
                <span>Notes</span>
              </td>
              <td class="row-padding">
                <input
                  class="input-style"
                  formControlName="notes"
                  type="text"/>
              </td>
            </tr>

            <tr>         
              <td class="row-padding">
                <span>Available Service Types</span>
              </td>
              <td class="row-padding" >
                <ul style="list-style-type: none;">
                <li *ngFor="let type of serviceTypes" >
                  <span>{{type.formattedName}} </span>
                  <input 
                    id="serviceTypeCheckBox" 
                    style="padding-left: 5px; vertical-align: middle; text-align: center;"
                    [checked]="selectedServiceTypeIds.indexOf(type.serviceTypeId) > -1"
                    type="checkbox"
                    (change)="toggleServiceTypeSelect(type.serviceTypeId);" >
                </li>
              </ul>
              </td>
            </tr>

            <tr>         
              <td class="row-padding">
                <span>Image segment start time threshold (seconds):</span>
              </td>
              <td class="row-padding">
                <input
                  class="input-style"
                  formControlName="imageSegmentStartTimeThreshold"
                  type="number"
                  max="60"
                  min="0"/>
              </td>
            </tr>
              
      </table>
    </div>
  </div>
</form>

  <span *ngIf="!form.valid" style="color: red;" class="m-form__help">
    Please complete all fields
  </span>

  <div style="height: 45px;">
    <button (click)="close()" class="btn btn-success" style="margin:15px; float:right">Cancel</button>
    <button (click)="saveAndClose()" class="btn btn-success" style="margin-top:15px; float:right">Save</button>
  </div>
</div>